<template lang="pug">
  v-row
    v-col(cols=12 md=8 lg=8)
        v-subheader Выберите необходимый курс, затем набор
        select-course-enrollment(
          v-model="selectedEnrollment"
          :get-courses-method="getCourses"
        )
    v-col(cols=12 md=4)
      v-row
        v-scroll-y-transition(leave-absolute)
          v-col(v-if="loading.channels" cols=12)
            v-skeleton-loader(
              type="list-item@6"
            )
        template(v-if="!loading.channels && selectedEnrollment")
          v-col(cols=12)
            v-card.sdo-card
              v-sheet(
                color="grey lighten-4"
              ).d-flex.align-center.pl-5
                v-icon(
                  color="secondary"
                  size=60
                ) $telegram
                .title.secondary--text Телеграм канал набора
              v-card-text
                v-list
                  v-list-item(v-if="!loading.channels && !enrollments.telegram")
                    v-list-item-content
                      v-list-item-subtitle Не создано
                  v-list-item(
                    v-else
                    link
                    target="_blank"
                    :href="enrollments.telegram.invite_link"
                  ).my-2
                    v-list-item-content
                      v-list-item-subtitle.mb-1: strong Набор {{ selectedEnrollment.code}}

                      v-list-item-subtitle
                        | Дата создания -
                        strong  {{ enrollments.telegram.created_at | dp('h MMMM HH:mm') }}

            v-card.sdo-card.mt-5
              v-sheet(
                color="grey lighten-4"
              ).d-flex.align-center.pl-5
                v-icon(
                  color="secondary"
                  size=60
                ) $telegram
                .title.secondary--text Телеграм каналы групп
              v-card-text
                v-list
                  v-list-item(v-if="!loading.channels && !groups.length")
                    v-list-item-content
                      v-list-item-subtitle Чаты не найдены...
                  v-list-item(
                    v-for="group in groups"
                    :key="group.id"
                    target="_blank"
                    link
                    :href="group.telegram && group.telegram.invite_link"
                  ).my-2
                    v-list-item-action.mr-2: v-btn(
                      color="secondary"
                      icon
                      @click.stop.prevent=`$router.push({
                        name: 'GroupView',
                        params: {
                          groupId: group.id,
                          enrollmentId: selectedEnrollment.id,
                          id: selectedEnrollment.course_id,
                        }
                      })`
                    ): v-icon mdi-eye
                    v-list-item-content
                      v-list-item-subtitle {{ group.short_name }}
                      v-list-item-subtitle
                        | Дата создания -
                        strong  {{ group.telegram.created_at | dp('h MMMM HH:mm') }}
</template>

<script>
import SelectCourseEnrollment from '../../components/SelectCourseEnrollment.vue';

export default {
  components: {
    SelectCourseEnrollment,
  },
  data: () => ({
    channels: [],
    enrollments: [],
    selectedEnrollment: null,

    loading: {
      channels: false,
    },
  }),
  watch: {
    selectedEnrollment(val) {
      if (val) {
        this.init();
      }
    },
  },
  methods: {
    async init() {
      this.loading.channels = true;
      await this.fetchTelegramChannels();
      await this.fetchGroupList();
      this.loading.channels = false;
    },
    getCourses() {
      return this.$api.courses.index({
        'search[teacher_or_curator]': this.$user.data.id,
        expand: 'my_prior_records_30,my_active_prior_records_30,prior_records',
      });
    },
    async fetchTelegramChannels() {
      const resp = await this.$api.enrollments.getEnrollment(this.selectedEnrollment?.id, {
        params: {
          expand: 'telegram',
        },
      });
      this.enrollments = resp.data.data;
      this.enrollments.telegram = this.enrollments.telegram.find((i) => i.type === 1);
    },
    async fetchGroupList() {
      const params = {
        'search[prior_record_id]': this.selectedEnrollment?.id,
        'search[has_telegram]': true,
        expand: 'telegram',
      };
      const resp = await this.$api.groups.getGroupList(params);
      this.groups = resp.data.data
        .reduce((acc, group) => {
          const telegram = group.telegram?.find((i) => i.type === 1);
          return [...acc, { ...group, telegram }];
        }, []);
    },
  },
};
</script>
